<script setup lang="ts">
import { useMemoryEntriesStore } from '../stores/memory_entries'
import { useDocumentTitle } from '../composables/useDocumentTitle'
import MemoryBrowse from './MemoryBrowse.vue'

// Memory browse pane at `/memory`. Renders inside HomeView's shell. The
// scope / entries / detail frame lives in MemoryBrowse; with no entry
// open, the detail column holds a pointer to pick one (wide screens
// only — below xl the list is the whole page).
//
// Admin-only: the memory API is admin-gated and the `/memory` route
// redirects non-admins before this mounts. It trusts that gate.

const store = useMemoryEntriesStore()

useDocumentTitle('Memory')
</script>

<template>
  <section data-testid="memory-view">
    <MemoryBrowse>
      <div
        v-if="store.totalCount > 0"
        class="flex min-h-48 items-center justify-center rounded-2xl border border-dashed border-border-subtle p-6 text-center text-sm text-ink-faint max-xl:hidden"
        data-testid="memory-detail-placeholder"
      >
        Pick an entry to read it here.
      </div>
    </MemoryBrowse>
  </section>
</template>
